module.exports = __webpack_public_path__ + "img/arlet.cad156a2.jpg";